


export function useEnvironment() {

    const environment = process.env.NODE_ENV as any;

    const isProduction = environment == 'production' || environment == 'prod';
    const isAWSDev = environment == 'dev';
    const isLocalDev = environment == 'development';
    const isStaging = environment == 'staging';

    return {
        isProduction,
        isAWSDev,
        isLocalDev,
        isStaging
    }

}